import { Component, OnInit,ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
@Component({
  selector: 'app-ddf',
  templateUrl: './ddf.component.html',
  styleUrls: ['./ddf.component.scss']
})
export class DdfComponent implements OnInit {
  constructor(public authService: AuthService) {
    this.raci_id=Number(localStorage.getItem("id_raci"))
    this.ls_area();
    this.ls_proceso();
    this.ls_pa();
   }
   matriz_ap=[]
   matriz_p=[]
    ls_matriz(){
    //console.log(this.area);
    //console.log(this.procesos);
    //console.log(this.rel_pa);
    //console.log("proceso"+this.area.length)

   }
   bndmnugral=true;
   oculta_menu(){
     //console.log("-");
     if(this.bndmnugral==true){
       this.bndmnugral=false;
     }else{
       this.bndmnugral=true;
     }
     //console.log(this.bndmnugral);
   }
  procesos=[]
  area=[]
  rel_pa=[]
  rel_pa_C=[]
  elementos_ddf=[];

  raci_id=0;
  ngOnInit() {
   
    this.elementos_ddf=[
      {id:1,id_pa:8649,tipo:"D",texto:"es viable?",si:0,no:0,textosi:"Documento con Informacion Basica",tiposi:"ES",textono:"Se Notifica que no es viable",tipono:"P",id_sig:-2 },
      {id:2,id_pa:8661,tipo:"P",texto:" proceso de prueba",si:0,no:0,textosi:"",tiposi:"",textono:"",tipono:"",id_sig:-2 },
      {id:3,id_pa:8666,tipo:"ES",texto:"proceso de prueba Entrada y Salida",si:0,no:0,textosi:"",tiposi:"",textono:"",tipono:"",id_sig:-2 }
    ]
    //var rect= document.getElementById("p_2");
    //console.log( document.documentElement.clientTop) ;
  
  }
  async ls_pa(){
    this.rel_pa=[];
    let postData = {
      id_raci:this.raci_id
    }
  await   this.authService.service("/api/get_pa_2",postData)
  .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);             
        for(var i=0;i<res.length;i++){
          //console.log(res[i]);   
          if(res[i].rol=="R" || res[i].rol=="AR" ){
          this.rel_pa.push(
              {id:res[i].id,
              p:res[i].id_tarea,
              a:res[i].id_area,
              rol:res[i].rol,
              entregable:res[i].entregable,
              impacto:res[i].impacto,
              ttime:res[i].ttime,
              tipo_time:res[i].tipo_time,
              c:"X",
              valor:res[i].valor});
            }else if( res[i].rol=="C" ){
              this.rel_pa_C.push(
                {id:res[i].id,
                p:res[i].id_tarea,
                a:res[i].id_area,
                rol:res[i].rol,
                entregable:res[i].entregable,
                impacto:res[i].impacto,
                ttime:res[i].ttime,
                tipo_time:res[i].tipo_time,
                c:"X",
                valor:res[i].valor});
            }

        }
        
        this.ls_matriz();
        //console.log(res); 
        //this.load_rasci(); 
        //console.log(this.rel_pa); 
        
        for(var i=0;i<this.area.length;i++){
          this.matriz_p=[];
          for(var j=0;j<this.procesos.length;j++){
            var texto_proceso=""
            var id_proceso=0       
            for(var k=0;k<this.rel_pa.length;k++){
                if(this.rel_pa[k].a==this.area[i].id && 
                    this.rel_pa[k].p==this.procesos[j].id && 
                    (this.rel_pa[k].rol=='R' || this.rel_pa[k].rol=='AR')){
                      //console.log("proceso")
                      id_proceso=this.rel_pa[k].id
                      texto_proceso= this.area[i].area +" realiza"+ this.procesos[j].proceso+
                      "consultado por: "
                      var consultados=""
                      for(var l=0;l<this.rel_pa_C.length;l++){
                        if(this.rel_pa_C[l].p==this.procesos[j].id){
                          for(var m=0;m<this.area.length;m++){
                            if(this.rel_pa_C[l].a==this.area[m].id){
                              consultados+=this.area[m].area;
                            }
                          }
                        }
                      }
                      texto_proceso=texto_proceso+consultados;
                }
    
            }
            //console.log("proceso")
            /*console.log({
              id:id_proceso,
              id_proceso:this.procesos[j].id ,
              id_area:this.area[i].id ,
              texto:texto_proceso,
            });*/
            this.matriz_p.push({
              id:id_proceso,
              id_proceso:this.procesos[j].id ,
              id_area:this.area[i].id ,
              area:this.area[i].area,
              texto:texto_proceso,
              class:"SS"
            })
            
          }
          //console.log(this.matriz_p);
          this.matriz_ap.push(this.matriz_p)
        }
        //console.log("proceso_ap")
        console.log(this.matriz_ap)

      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          //swal.fire('¡Información incorrecta!', '', 'error');
      });  

}
async ls_proceso(){
    let postData = {
      id_raci:this.raci_id
    }
    this.procesos=[];
 await this.authService.service("/api/get_proceso",postData)
  .then(
    data => {
      var dat = JSON.stringify(data);
      var res = JSON.parse(dat);  
      //console.log(data);                    
      for(var i=0;i<res.length;i++){

        this.procesos.push( { valor_:res[i].valor_,valor:res[i].valor,
          id:res[i].id, 
          proceso:res[i].Titulo,
          descripcion:res[i].Descripcion,
          idx:res[i].idx,
          raci2:Number(res[i].id_raci2)}
        );
      }
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de)
        //swal.fire('¡Información incorrecta!', '', 'error');
    });  
  }
  ls_area(){
    let postData = {
      id_raci:this.raci_id
    }
    this.area=[];
    this.authService.service("/api/get_area",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);                        
        for(var i=0;i<res.length;i++){
          //console.log("get_area");
          //console.log(res[i]);
          var tx_area= "";
          if(res[i].id_ant==0){
            tx_area=res[i].area
          }else{
            if(res[i].role.toString()==""){
              tx_area=res[i].area;
            }else{
              tx_area=res[i].role;
            }
          }
          this.area.push({ 
            foto:res[i].foto==null?"image-none.jpg":res[i].foto,
            id:res[i].id,
            area:tx_area,
            idx:res[i].idx,
            id_ant:res[i].id_ant
          });        
        }
        
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          //swal.fire('¡Información incorrecta!', '', 'error');
      });  
  }
  subp={
    id:0,
    tipoP:"",
    opsi:"",
    opno:"",
    texto:"",
    textosi:"",
    textono:""
  }
  caso_no=[
    {id:0,id_ddf:1,texto:"pues no",tipo:"P"}
  ]
  conectores=[
    {a:0,p:0,tipo:"LI"},
    {a:1,p:0,tipo:"SS"},
    {a:1,p:2,tipo:"SD"},
    {a:2,p:0,tipo:"SS"},
    {a:3,p:0,tipo:"SS"},
    {a:4,p:0,tipo:"SS"},
    {a:5,p:0,tipo:"SL"},
    {a:5,p:1,tipo:"LS"},
    {a:4,p:2,tipo:"LS"},
    {a:3,p:2,tipo:"SS"},
    {a:2,p:2,tipo:"SS"},
    {a:1,p:3,tipo:"LI"},
    {a:2,p:3,tipo:"SS"},
    {a:3,p:3,tipo:"SS"},
    {a:4,p:3,tipo:"SL"},
    {a:4,p:4,tipo:"LL"},
    {a:4,p:1,tipo:"SD"},
    {a:4,p:5,tipo:"LS"},
    {a:3,p:5,tipo:"SS"},
    {a:2,p:5,tipo:"SS"},
    {a:1,p:6,tipo:"LL"},

    {a:1,p:-1,tipo:"LI"},
    {a:2,p:-1,tipo:"SS"},
    {a:3,p:-1,tipo:"SS"},
    {a:4,p:-1,tipo:"SS"},
    {a:5,p:-1,tipo:"SL"},
    
  ]
  id_no=0;
  v_subp(id){
    this.subp.id=id;
  }
  ps_no(id){
    this.id_no=id
  }
  gda_ps_no(){
    if(this.subp.tipoP=="")return;
    if(this.subp.texto=="")return;
    this.caso_no.push({
      id:(this.caso_no.length+1),
      id_ddf:this.id_no,
      tipo:this.subp.tipoP,
      texto:this.subp.texto});    
    this.caso_no.sort((a,b) => b.id.toString().localeCompare(a.id.toString())); 
    //console.log(this.caso_no)
  }
  gda_ps(){
    if(this.subp.tipoP=="")return;
    if(this.subp.texto=="")return;
    //console.log(this.subp.tipoP)
    this.elementos_ddf.push({
      id:(this.elementos_ddf.length+1),
      id_pa:this.subp.id,
      tipo:this.subp.tipoP,
      texto:this.subp.texto,
      si:0,
      no:0,
      textosi:"",
      tiposi:"",
      textono:"",
      tipono:"",
      id_sig:-2 
    });    
    this.elementos_ddf.sort((a,b) => 
    b.id.toString().localeCompare(a.id.toString()) 
  ); 
  }

 /*
 
  get_consultado_tx(c){
    var con=""
    if(c.length==0){
      return ""
    }else{
      for(var i=0;i<c.length;i++){  
        con=con+c[i].texto
      }
      return con
    }

  }



  pa2_(p,a){  
    console.log(this.rel_pa)

    var texto=""
    var tipo=""
    var id_pa=0
    var consultado=[]
    var bnd=false;
    var elemento_={texto:""}
    var arr_p=[];
    for(var i=0;i<this.rel_pa.length;i++){ 
        if(p.id==this.rel_pa[i].p && this.rel_pa[i].rol=="C"  ){
          arr_p.push(this.rel_pa[i])
        }
        if(p.id==this.rel_pa[i].p && a.id==this.rel_pa[i].a ){
          if(this.rel_pa[i].rol=="R" || this.rel_pa[i].rol=="AR"){
            bnd=true;
            id_pa=this.rel_pa[i].id;
            texto=this.rel_pa[i].id+" "+a.area+ " realiza "+ p.proceso //+" " +this.rel_pa[i].rol  
            tipo="proceso"
            elemento_={texto:texto}
          }
          if(this.rel_pa[i].rol=="I"){
            tipo="inicio"
            bnd=true;
            elemento_={texto:p.proceso}
          }
          if(this.rel_pa[i].rol=="C"){
            tipo="proceso"
            elemento_={texto:"C"}
            //bnd=true;
          }
        
        } 
    }          
    if(bnd){
      //console.log(p)
      //console.log(arr_p)
      var con=""
      var bndc=0;
      for(var i=0;i<arr_p.length;i++){ 
        for(var j=0;j<this.area.length;j++){
          if(arr_p[i].a==this.area[j].id){
            if(bndc>0)con=con+", "
            con=con+this.area[j].area;
            bndc=1;
          }
        }

      }
      var proceso=""
      for(var j=0;j<this.elementos_ddf.length;j++){
        if(id_pa==this.elementos_ddf[j].id_pa){
          //console.log(this.elemento(this.elementos_ddf[j].tipo,this.elementos_ddf[j].texto,""))
          console.log(this.elementos_ddf[j])
          proceso+=this.elemento(this.elementos_ddf[j].tipo,this.elementos_ddf[j],"",id_pa);
        }
        
      }
      //console.log(proceso)
      proceso+=this.elemento(tipo,elemento_.texto,con,id_pa);
      return proceso
    }else{
      return "";
    }
  }*/
 /*elemento(tipo,proceso,consultado,id){   
    var c= consultado==""?"":"<b style='font-size:10'> consultado por: ("+consultado+")</b>"
    switch (tipo) {
      case "P":
        return  "<table>"+
                    "<tr>"+
                      "<td><div class='ddf_proceso' id='p_"+id+"'>"+proceso.texto+"</div></td>"+
                    "</tr>"+
                "</table>";
      case "ES":
          return  "<table>"+
                    "<tr>"+
                      "<td><div class='ddf_es'  id='p_"+id+"'>"+proceso.texto+"</div></td>"+
                    "</tr>"+
                    " <tr>"+
                    "   <td></td>"+
                    "</tr>"+
                  "</table>";     
  
      case "proceso":
          return  "<div class='btn btn-success btn-sm'  data-toggle='modal' data-target='#subp' > (**+) </div>"+
            "<div class='ddf_proceso p_"+id+"'  name='p_"+id+"'>"+proceso+c+"</div>"
         
        break;
        case "inicio":
          return  "<table>"+
                      "<tr>"+
                        "<td><div class='ddf_inicio'  id='p_"+id+"'>"+proceso+"</div></td>"+
                        "<td>-</td>"+
                      "</tr>"+
                      "<tr>"+
                        "<td></td>"+
                      "</tr>"+
                  "</table>";         
        break;
        case "D":
          return  ""+
            "<table border=0 >"+
            " <tr>"+
            "   <td></td>"+
            "   <td></td>"+
            "   <td></td>"+
            "   <td><div class='ddf_proceso' >"+proceso.textosi+"</div></td>"+
            " </tr>"+
            " <tr>"+
            "   <td></td>"+
            "   <td></td>"+
            "   <td></td>"+
            "   <td>|</td>"+
            " </tr>"+
            " <tr>"+
            "   <td></td>"+
            "   <td></td>"+
            "   <td></td>"+
            "   <td>Si</td>"+
            " </tr>"+
            " <tr>"+
            "   <td><div class='ddf_proceso'  id='p_"+id+"'>"+proceso.textono+"</div></td>"+
            "   <td>-</td>"+
            "   <td>No</td>" +
            "   <td><div class='ddf_desicion'>"+proceso.texto+"</div></td>"+
            " </tr>"+
            " <tr>"+
            "   <td> </td>"+
            "   <td> </td>"+
            "   <td> </td>"+
            "   <td> |</td>"+
            " </tr>"+
            "</table>";         
        break;
      default:
        return proceso;
        break;
    }
  }*/
}



